import React from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Loader.module.scss';
import Typography from '../../kit/atoms/Typography';

const Loader: React.FC = () => {
    const st: CssModuleType = currentCssModule;

    return (
        <div className={st.loader}>
            <Typography>Loading products...</Typography>
            <div className='loader'></div>
        </div>
    );
};

export default Loader;
